

<mat-chip-set>
  @for (element of filtersList; track element) {
  @let label = getLabel(element.id);
  <mat-chip-row (click)="openDialogFilter(element.id)" class="filter-chip" [title]="getFullTitleFilter(element.id)">
    {{element.label + (label ? label: '')}}
    @if(label){
    <mat-icon matChipRemove (click)="clearFilter($event, element.id)">cancel</mat-icon>
    }
  </mat-chip-row>
  }
</mat-chip-set>

<bt-loader [loaderId]="photographersLoaderId">
  @if(photographers.data){
  <bt-table [dataSource]="photographers.data" [displayedColumns]="columns" />
  }
</bt-loader>

<ng-template #menuColumn let-row="row">
  <bt-menu [show]="row.showMenu" (hidden)="row.showMenu = false" (showed)="row.showMenu = true">
    <div class="menu-item" (click)="onItemAction(row, sidebarType.editInfo)">
      <i class="fa fa-edit"></i>Edit info
    </div>
    <div class="menu-item" (click)="onItemAction(row, sidebarType.customOrder)">
      <i class="fa fa-plus-circle"></i>Make custom order
    </div>
    <div class="menu-item warning" (click)="onItemAction(row, sidebarType.deleteAction)">
      <i class="fa fa-trash"></i>Delete photographer
    </div>
  </bt-menu>
</ng-template>
<ng-template #brandsColumn let-row="row">
  <span>{{getBrandColumnValue(row)}}</span>
</ng-template>
<ng-template #discountColumn let-row="row">
  <span>{{ row.discountPercentage }}%</span>
</ng-template>
<ng-template #discountThresholdColumn let-row="row">
  <span>{{ row.discountThreshold | currency: 'EUR'}}</span>
</ng-template>
<ng-template #automaticRenewalColumn let-row="row">
  <span style="display: flex; justify-content: center;">
    <i class="fa-solid" style="font-size: x-large;"
      [ngClass]="row.automaticRenewal ? 'fa-circle-check': 'fa-circle-xmark'"
      [ngStyle]="{'color': row.automaticRenewal ? 'green' : 'red'}"></i>
  </span>
</ng-template>
<ng-template #hiredFromColumn let-row="row">
  <span>{{ parseDate(row.hiredFrom ) | date: 'dd/MM/yyyy'}}</span>
</ng-template>
<ng-template #hiredUntilColumn let-row="row">
  <span>{{ parseDate(row.hiredUntil ) | date: 'dd/MM/yyyy'}}</span>
</ng-template>
<ng-template #ordersHistoryColumn let-row="row">
  <span>
    <div (click)="openOrdersHistory(row.personId)" class="open-history-button">
      <i class="fa-solid fa-up-right-from-square"></i>
    </div>
  </span>
</ng-template>
<ng-template #montlyPaidColumn let-row="row">
  <span>{{ row.monthlyPaid | currency: 'EUR'}}</span>
</ng-template>
<ng-template #shotCostColumn let-row="row">
  <span>{{ row.shotCost | currency: 'EUR'}}</span>
</ng-template>
<ng-template #totalPaidColumn let-row="row">
  <span>{{ row.totalPaid | currency: 'EUR'}}</span>
</ng-template>

@if(tmpPhotog && currentSidebar === sidebarType.editInfo){
<bt-sidebar sidebarTitle="Edit info" (exit)="tmpPhotog = null">
  <bt-sidebar-editinfo [photographer]="tmpPhotog" (saved)="savedInfo()"></bt-sidebar-editinfo>
</bt-sidebar>
}

@if(tmpPhotog && currentSidebar === sidebarType.customOrder){
<bt-sidebar sidebarTitle="Custom order" (exit)="tmpPhotog = null">
  <bt-sidebar-customorder [photographer]="tmpPhotog" (created)="createdCustomOrder()"></bt-sidebar-customorder>
</bt-sidebar>
}

@if(tmpPhotog && currentSidebar === sidebarType.deleteAction){
<bt-sidebar sidebarTitle="Dismiss photographer" (exit)="tmpPhotog = null">
  <div class="flex overflow vertical">
    <div class="flex-1 flex center">
      <div>
        Are you sure you want to <b>delete</b> {{tmpPhotog.fullName}}? Deleting photographer, you will remove him from
        the application
      </div>
    </div>
    <div class="flex-0">
      <button class="full-width warning" (click)="deletePhotographer()"><i class="fa fa-trash"></i>Delete
        photographer</button>
    </div>
  </div>
</bt-sidebar>
}


@if(showModal){
<bt-modal modalTitle="Filters" [modalContent]="modalContent" (exit)="closeModal()" />
}
